import React from 'react'

const Machine = ({ name }) => {
  return <>{name}</>
}

export default Machine
